/*
 * @Author: Teemo Ding
 * @Date: 2021-07-21 10:02:12
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-21 13:11:53
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/payment.ts
 */

import { post, get } from 'src/tools/server';

export const init_paymentData = (salesChannelUuid: string, params?) => {
  return get<any>(
    `/portal/salesChannel/${salesChannelUuid}/setting/payment`,
    params || {},
  );
};

export const init_gateways = (salesChannelUuid: string, data) => {
  return post<any>(
    `/portal/salesChannel/${salesChannelUuid}/methodInfo/list`,
    data,
    {},
  );
};

export const save_paymentData = (salesChannelUuid: string, data, params) => {
  return post<any>(
    `/portal/salesChannel/${salesChannelUuid}/setting/payment`,
    data,
    params || {},
  );
};
